import axios from "axios";

const setHeaders = (token) => {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
};

// Set profile ID on a User object in Azure AD
// eslint-disable-next-line import/prefer-default-export
export const setProfileIdInAzureAD = async (profileId, accessToken) => {
  return axios.post(
    `/api/membersArea/saveProfileId`,
    { profileId },
    setHeaders(accessToken)
  );
};
